import React, { useState, useEffect } from "react";
import "./ImageCropModal.css";
import CropCanvas from "../CropCanvas";

const ImageCropModal = ({
  isOpen = true,
  onClose = () => {},
  onCrop = () => {},
  imageSrc,
  imageLoading
}) => {
  const [zoom, setZoom] = useState([1]);
  const [rotation, setRotation] = useState(0);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleZoomChange = (value) => {
    setZoom([value]);
  };

  const handleRotationChange = (value) => {
    setRotation(value);
  };

  const handlePositionChange = (value) => {
    setPosition(value);
  };

useEffect(() => {
  if (!imageSrc) return;

  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = imageSrc;

  img.onload = () => {
    const cropSize = 300; // must match your crop box size in px

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = cropSize;
    canvas.height = cropSize;

    ctx.clearRect(0, 0, cropSize, cropSize);

    // Clip to crop box to avoid overflow
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, cropSize, cropSize);
    ctx.clip();

    // Move to center of crop box
    ctx.translate(cropSize / 2, cropSize / 2);

    // Translate by position.x/y
    ctx.translate(position.x, position.y);

    // Rotate
    ctx.rotate((rotation * Math.PI) / 180);

    // Scale
    ctx.scale(zoom[0], zoom[0]);

    // Draw image centered at origin
    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    ctx.restore();

    const previewDataUrl = canvas?.toDataURL("image/png");
    //   const previewDataUrl = canvas?.toDataURL("image/png");
    setPreviewUrl(previewDataUrl);
  };
}, [zoom, rotation, position, imageSrc]);



  if (!isOpen) return null;

  return (
    <div className="modal-overlay __imgCrop_mod">
      <div className="modal-content_image-crop">
        <div className="modal-header">
          <h3>Crop Image</h3>
        </div>

        <div className="modal-body">
          <div className="crop-area-container">
            <CropCanvas
              imageSrc={imageSrc}
              zoom={zoom[0]}
              rotation={rotation}
              position={position}
              onZoomChange={handleZoomChange}
              onPositionChange={handlePositionChange}
            />
          </div>

          <div className="controls">
            {/* Zoom Control */}
            <div className="control-group">
              <div className="control-header">
                <span>Zoom</span>
                <span className="control-subtext">
                  {Math.round(zoom[0] * 100)}%
                </span>
              </div>
              <input
                type="range"
                min="1"
                max="3"
                step="0.1"
                value={zoom[0]}
                onChange={(e) => handleZoomChange(parseFloat(e.target.value))}
                className="slider"
              />
            </div>

            {/* Rotation Control */}
            <div className="control-group">
              <div className="control-header">
                <span>Rotation</span>
                <span className="control-subtext_">{rotation.toFixed(1)}°</span>
              </div>
              <input
                type="range"
                min="0"
                max="360"
                step="1"
                value={rotation}
                onChange={(e) =>
                  handleRotationChange(parseFloat(e.target.value))
                }
                className="slider"
              />
            </div>

            {/* Preview */}
            <div className="preview">
              <span className="control-header">Preview</span>
              <div className="preview-container">
                <div className="preview-box">
                  {previewUrl && (
                    <img
                      src={previewUrl}
                      alt="Crop preview"
                      className="preview-img"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="_cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button className="anime-btn  _addComm_btn" disabled={imageLoading} onClick={() => onCrop(previewUrl)}>
            {!imageLoading?"Apply": "Applying..."}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropModal;
